export class Constants {
    public static maxImageFileSize: number = 200000;
    public static ROLES = {
        ADMINISTRATOR: 'Administrator',
        EDITOR: 'Editor',
        VIEWER: 'Viewer'
    };
}